module.exports = __webpack_public_path__ + "static/media/practical_case.1cf8c594.png";